import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ $customColor }) => $customColor};
`;

const CircularLoader = ({ color, size, className }) => {
  return (
    <StyledCircularProgress
      $customColor={color}
      size={size}
      className={className}
    />
  );
};

export default CircularLoader;

CircularLoader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};

CircularLoader.defaultProps = {
  color: 'var(--color-i-green)',
  size: 40,
  className: ''
};
